import { useSpreadsheetDataEntityFiltersSelector } from '~/store/spreadsheetData/filtering/useSpreadsheetDataEntityFilters';
import { useSpreadsheetPreviewFilterStateSelector } from './activeMapElements.selectors';

export const useSpreadsheetPreviewFilters = () => {
  const spreadsheetPreviewFilterState = useSpreadsheetPreviewFilterStateSelector();

  return useSpreadsheetDataEntityFiltersSelector({
    filter: spreadsheetPreviewFilterState,
  });
};
